import { ORDER_APIS } from "@/api_framework/api_config";
import { ICartUpdateResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export interface ITransferCancel {
  transfer_order_id?: string;
  reason?: string;
}

export const useInvoiceCanceltransferOrderAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (invoicePayload: ITransferCancel) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .post(`${ORDER_APIS?.CANCEL_TRANSFER_ORDER?.baseURL}`, invoicePayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartUpdateResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);

              return { status: true, message: null };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: null };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
